
/* eslint-disable */
import axios, { AxiosResponse } from "axios";
import { Emotion, Subject, EmotionData, SubjectsIdsByGender, SubjectsIdsByAgeGroup, Filter } from '../../interfaces/Interfaces'

const baseUrl: string = process.env.VUE_APP_API_BASE_URL
const urlParams = new URLSearchParams(window.location.search)
const code = urlParams.get('code')

const state = {
  emotions: [],
  emotionsWithFilters: [],
  subjects: [],
  projectName: '',
  projectId: '',
  videoName: '',
  videoFullName: '',
  videoId: '',
  multipleEmotions: [],
  showOnlyFilteredData: false,
  emotionSettings: [],
  clientMode: false,
  yMaxValue: 3,
  filters: [],
}

const getters = {
  getEmotions: (state: any): Emotion[] | [] => state.emotions,
  getEmotionsWithFilters: (state: any): Emotion[] | [] => state.emotionsWithFilters,
  getProjectName: (state: any): string | [] => state.projectName,
  getProjectId: (state: any): string | [] => state.projectId,
  getVideoName: (state: any): string | [] => state.videoName,
  getVideoFullName: (state: any): string | [] => state.videoFullName,
  getVideoId: (state: any): string | [] => state.videoId,
  getSubjects: (state: any): Subject[] | [] => state.subjects,
  getMultipleEmotions: (state: any): [] => state.multipleEmotions,
  getShowOnlyFilteredData: (state: any): boolean => state.showOnlyFilteredData,
  getEmotionSettings: (state: any): [][] => state.emotionSettings,
  getYMaxValue: (): number => state.yMaxValue,
  isClientMode: (): boolean => state.clientMode,
  getFilters: (state: any): Filter[] | [] => state.filters,

  getSubjectsByGender: (state: any): SubjectsIdsByGender => {
    let males: string[] = []
    let females: string[] = []

    state.subjects.map((subject: Subject): void=> {
      if (subject['gender'] === 'male') males.push(subject['id'])
      else if (subject['gender'] === 'female') females.push(subject['id'])
      else return
    })

    const splitSubjects: SubjectsIdsByGender = {
      'males': males,
      'females': females
    }
    return splitSubjects
  },

  getSubjectsByAgeGroup: (state: any): SubjectsIdsByAgeGroup => {

    let firstGroup: string[] = []
    let secondGroup: string[] = []
    let thirdGroup: string[] = []

    const firstAgeGroupLimit: number = 35
    const secondAgeGroupLimit: number = 50
    const thirdAgeGroupLimit: number = 70

    state.subjects.map((subject: Subject): void=> {
      if (subject['age'] <= firstAgeGroupLimit) firstGroup.push(subject['id'])
      else if (subject['age'] > firstAgeGroupLimit && subject['age'] <= secondAgeGroupLimit) secondGroup.push(subject['id'])
      else thirdGroup.push(subject['id'])
    })
    
    const splitSubjects: SubjectsIdsByAgeGroup = {
      'firstGroup': firstGroup,
      'secondGroup': secondGroup,
      'thirdGroup': thirdGroup
    }
    return splitSubjects
  },

  getSubjectsByFilter: (state: any) => (index: number): any => {
    const selectedFilter = state.filters && state.filters[index]
    if (!selectedFilter) {
      return {}
    }

    const filterName: string = selectedFilter.name
    const splitSubjects: any = {}

    for (const key of selectedFilter.answers || []) {
      splitSubjects[key] = []
    }

    state.subjects.forEach((subject: Subject): void => {
      const subjectFilters: any = (subject as any).filters
      if (!subjectFilters) {
        return
      }

      const filterValue = subjectFilters[filterName]
      if (filterValue == null) {
        return
      }

      if (!splitSubjects[filterValue]) {
        splitSubjects[filterValue] = []
      }

      splitSubjects[filterValue].push((subject as any).id)
    })

    return splitSubjects
  },
}

const actions = {
  async fetchEmotions({ commit }: any) {

    if (!code) return;

    let codeExpired: boolean = false
    let projectName: string = ''
    let projectId: string = ''
    let videoName: string = ''
    let videoFullName: string = ''
    let videoId: string = ''
    let model: string = 'ms'
    let showOnlyFilteredData: boolean = false

    try {
      const response = await axios.get(`${baseUrl}/public-access/${code}`)
      projectName = response.data['project_name']
      projectId = response.data['project']
      videoName = response.data['stimulus_name']
      videoFullName = response.data['stimulus_full_name']
      videoId = response.data['stimulus']
      model = response.data['analysis_model']
      const multipleEmotions = response.data['emotions']
      showOnlyFilteredData = response.data['show_only_filtered_data']
      const emotionSettings = [
        response.data['general_settings'],
        response.data['filter_settings']
      ]

      const clientMode = !response.data['admin']
      const yMaxValue = response.data['ymax']

      commit('setMultipleEmotions', multipleEmotions)
      commit('setShowOnlyFilteredData', showOnlyFilteredData)
      commit('setEmotionSettings', emotionSettings)
      commit('setClientMode', clientMode)
      commit('setYMaxValue', yMaxValue)
    } catch (err) {
      codeExpired = true;
      // throw err;
    }

    if (codeExpired) {
      commit('setProjectName', '_')
      return;
    }
  
    axios.get(`${baseUrl}/analysis-results/${projectName}/${videoName}/${model}`)
    .then((res: AxiosResponse): void => {

      // Tranforms data before store it to match originary expected shape
      let emotions: Emotion[] = []
      const data = res.data.data
      const subjects = res.data.subjects[0]
      let timestampsArr: number[] = data['timestamps']
      let idsArr: number[] = data['ids']

      Object.keys(data['emotions']).forEach((el: string) => {
        const emotion: number[][] = data['emotions'][el]
        const newEmotionDataFormat: EmotionData[] = emotion.map(function(timestamp: number[], index: number) {
          let timestampData = {"Timestamp": timestampsArr[index]} as any
          let i: number
          for(i=0; i<timestamp.length; i++) {
            timestampData[idsArr[i]] = timestamp[i].toString()
          }
          return timestampData
        })

        var emotionString: string = el.charAt(0).toUpperCase() + el.slice(1)
        if (emotionString === 'Contempt' && model === 'aws') {
          emotionString = 'Confused'
        }
        let emotionObject: Emotion = {
          type: emotionString,
          data: newEmotionDataFormat
        }

        emotions.push(emotionObject)
      })

      const neutralEmotion = emotions.find(emotion => emotion.type === 'Neutral');
      if (neutralEmotion) {
        const attentionData: EmotionData[] = neutralEmotion.data.map(neutralTimestampData => {
          const attentionTimestampData: EmotionData = { Timestamp: neutralTimestampData.Timestamp } as any;
          Object.keys(neutralTimestampData).forEach(key => {
            if (key !== 'Timestamp') {
              const neutralValue = parseFloat(neutralTimestampData[key] as string);
              // Ensure neutralValue is a number and not NaN before calculation
              if (!isNaN(neutralValue)) {
                attentionTimestampData[key] = (1 - neutralValue).toString();
              } else {
                // Handle cases where neutralValue might not be a valid number, e.g., set to '0' or skip
                attentionTimestampData[key] = '0'; // Or handle as per your logic
              }
            }
          });
          return attentionTimestampData;
        });

        const attentionEmotion: Emotion = {
          type: 'Attention',
          data: attentionData
        };
        emotions.push(attentionEmotion);
      }

      const scenes = JSON.parse(JSON.stringify(res.data.scenes))

      const subjectsWithFilters = subjects.filter(
        (s: Subject) => s.filters && Object.keys(s.filters).length > 0
      );

      const idsWithFilters = new Set(subjectsWithFilters.map((s: Subject) => s.id));

      const emotionsWithFilters = emotions.map((emotion: Emotion) => ({
        ...emotion,
        data: emotion.data.map((row: EmotionData) => {
          const next: EmotionData = { Timestamp: row.Timestamp };
          Object.keys(row).forEach((key) => {
            if (key !== "Timestamp" && idsWithFilters.has(key)) {
              next[key] = row[key];
            }
          });
          return next;
        }),
      }));

      commit('setSubjects', res.data.subjects[0])
      commit('setEmotionsWithFilters', emotionsWithFilters)
      commit('scenes/setScenes', scenes, { root: true })
      commit('setProjectName', projectName)
      commit('setProjectId', projectId)
      commit('setVideoName', videoName)
      commit('setVideoFullName', videoFullName)
      commit('setVideoId', videoId)
      commit('setEmotions', emotions)
      commit('setFilters', res.data.filters)
    })
    .catch(err => {
      commit('setProjectName', projectName)
      commit('setVideoName', videoName)
      commit('setVideoFullName', videoFullName)
      commit('setEmotions', [])
      // throw err;
    });
  }
}

const mutations = {
  setProjectName: (state: any, projectName: string) => state.projectName = projectName,
  setProjectId: (state: any, projectId: string) => state.projectId = projectId,
  setVideoName: (state: any, videoName: string) => state.videoName = videoName,
  setVideoFullName: (state: any, videoFullName: string) => state.videoFullName = videoFullName,
  setVideoId: (state: any, videoId: string) => state.videoId = videoId,
  setSubjects: (state: any, subjects: Subject[]): Subject[] | [] => state.subjects = subjects,
  setEmotions: (state: any, emotions: Emotion[]): Emotion[] | [] => state.emotions = emotions,
  setEmotionsWithFilters: (state: any, emotions: Emotion[]): Emotion[] | [] => state.emotionsWithFilters = emotions,
  setMultipleEmotions: (state: any, multipleEmotions: []): [] => state.multipleEmotions = multipleEmotions,
  setShowOnlyFilteredData: (state: any, showOnlyFilteredData: boolean) => state.showOnlyFilteredData = showOnlyFilteredData,
  setEmotionSettings: (state: any, emotionSettings: [][]): [][] => state.emotionSettings = emotionSettings,
  setClientMode: (state: any, clientMode: boolean) => state.clientMode = clientMode,
  setYMaxValue: (state: any, value: number): number => state.yMaxValue = value,
  setFilters: (state: any, filters: Filter[]): Filter[] | [] => state.filters = filters,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
